import '@ninja';
import rootRoutes from 'router/rootRoutes';
import 'react-data-grid/lib/styles.css';
import { renderRoutes } from 'router/renderRoutes';
import useBootstrapUser from 'store/redux/hooks/actions/useBootstrapUser';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect } from 'react';
import { ninjaEvents } from 'tracking/ninjaEvents';
import useAuth from 'utils/auth/useAuth';
import useWorkspace from 'store/redux/hooks/useWorkspace';
import useQueryParams from 'hooks/useQueryParams';
import { setApiAuthToken } from 'store/redux/utils/authtoken';
import UrlHelper from 'common/utils/url-helper';
// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';
// import storage from '@ninja/storage';

// window.Pusher = Pusher;

const App = () => {
  const { bootstrapWithToken } = useBootstrapUser();
  const history = useHistory();
  const { searchParams } = useQueryParams();

  const { user } = useAuth();
  const { workspace } = useWorkspace();

  useEffect(() => {
    ninjaEvents.emit('app_initialized');

    history.listen(() => {
      ninjaEvents.emit('pageview', { location, user, workspace });
    });
  }, []);

  useEffect(() => {
    if (searchParams.login_access_token) {
      bootstrapWithToken(searchParams.login_access_token).then(() => {
        history.push('/dashboard');
      });
    }
  }, [searchParams.login_access_token]);

  return renderRoutes(rootRoutes);
};

export default App;
